const strings = {
  detalhes: 'Detalhe da Validação',
  equipe: 'Equipe',
  buttonTitle: 'Filtrar',
}

export default strings
